// tslint:disable: variable-name
import { BaseResourceModel } from '../../models/base-resource.model';
import { SetorAlmoxarifado } from './setor-almoxarifado.model';
import { Exercicio } from '../comum/exercicio.model';
import { Orgao } from '../comum/orgao.model';

export class InventarioEstoque extends BaseResourceModel {
  constructor(
    public id?: number,
    public data_inicio?: Date,
    public data_fim?: Date,
    public setorAlmoxarifado?: SetorAlmoxarifado,
    public exercicio?: Exercicio,
    public orgao?: Orgao,
    public observacao?: string,
    public finalizado?: boolean,
  ) {
    super();
  }
  static converteJson(json: any): InventarioEstoque {
    return Object.assign(new InventarioEstoque(), json);
  }
}
